import { connect } from 'react-redux';
import FireFliesView from './FireFliesView';
import { fetchIntegrations, getIntegrationForType } from "src/legacy/redux/actions/integrations.jsx";
import { activateAccount, updateFireFliesRecordingToggle } from "src/legacy/redux/actions/integrations/firefliesIntegration.jsx";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'fireflies');
  return {
    integration: integration,
    user: state.users.me,
    integrations: state.legacyRootReducer.settings.integrations,
    activeIntegrations: state.legacyRootReducer.settings.integrations.activated,
    activating: state.legacyRootReducer.settings.integrations.fireflies.activation.activating,
    deactivating: state.legacyRootReducer.settings.integrations.fireflies.deactivation.deactivating,
    enabled: state.legacyRootReducer.settings.integrations.fireflies.recordingEnabled.enabled,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    activateAccount: (configuration) => {
      return dispatch(activateAccount(configuration));
    },
    updateFireFliesRecordingToggle: (enabled) => {
      return dispatch(updateFireFliesRecordingToggle(enabled));
    },
  }
}

const FireFliesPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(FireFliesView);

export default withUseHooks(FireFliesPage);